import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';

import Box from '../../../elements/Box';
import Icon from '../../../elements/Icon';
import Text from '../../../elements/Text';
import Button from '../../../elements/Button';

function FareItemNoPriceAvailableCmp(props, ref) {
  const {
    onClick,
    onKeyDown,
    message,
    iconStyles,
    textIconStyles,
    messageStyles,
    linkAvailabilityStyles,
    showIcon,
    showMessage,
    showLinkAvailability,
    tabIndex,
    showAsLink = true,
    addAriaLabel = true
  } = props;
  const { translate, direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  const label = translate('cmp-day-card-no-price-link', 'Check Availability');
  const ariaLabel = addAriaLabel
    ? translate('cmp-day-card-no-price-link', 'Check Availability')
    : null;
  const Tag = showAsLink ? Button : Text;

  const handleClick = (e) => onClick(e, label);
  const handleKeyDown = (e) => {
    onKeyDown(e, label);
  };
  return (
    <Box
      display="flex"
      flexDirection="column"
      textAlign="center"
      marginTop="auto"
      className={className}
      style={style}
      focusReferences={ref}
    >
      {showIcon && (
        <Text margin="0" {...textIconStyles}>
          <Icon icon="search" {...iconStyles} />
        </Text>
      )}
      {showMessage ? (
        <Text {...messageStyles}>{translate(message, 'No available results')}</Text>
      ) : (
        <Text className="fr-sr-only">{translate(message, 'No available results')}</Text>
      )}
      {showLinkAvailability && (
        <Tag
          color="link"
          ariaLabelInFocus
          {...linkAvailabilityStyles}
          dataReactCmpOwner="checkAvailabilityCallToAction"
          onClick={handleClick}
          onKeyDown={handleKeyDown}
          ariaLabel={ariaLabel}
          className={linkAvailabilityStyles.className}
          tabIndex={tabIndex ? 0 : -1}
        >
          {label}
        </Tag>
      )}
    </Box>
  );
}

FareItemNoPriceAvailableCmp.propTypes = {
  /**
   * message to show
   */
  message: PropTypes.string,
  /**
   * Props of the icon
   */
  iconStyles: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of the text icon
   */
  textIconStyles: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of the message
   */
  messageStyles: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of the linkAvailabilityStyles
   */
  linkAvailabilityStyles: PropTypes.objectOf(PropTypes.any),
  /**
   * Turn off or on the showIcon section
   */
  showIcon: PropTypes.bool,
  /**
   * Turn off or on the showMessage section
   */
  showMessage: PropTypes.bool,
  /**
   * Turn off or on the showLinkAvailability section
   */
  showLinkAvailability: PropTypes.bool,
  /**
   * Event fired when clicked check availability link
   */
  handleClick: PropTypes.func,
  /**
   * Call to action onClick event
   */
  onClick: PropTypes.func,
  /**
   * Call to action onKeydown event
   */
  onKeyDown: PropTypes.func,
  /**
   * Define if the callToAction will have focus for Screen Readers
   */
  tabIndex: PropTypes.bool
};

FareItemNoPriceAvailableCmp.defaultProps = {
  message: 'cmp-day-card-no-price',
  iconStyles: {},
  textIconStyles: {},
  messageStyles: {},
  linkAvailabilityStyles: {},
  showIcon: true,
  showMessage: true,
  showLinkAvailability: false,
  handleClick: () => {},
  onClick: () => {},
  onKeyDown: () => {},
  tabIndex: true
};

const FareItemNoPriceAvailable = React.forwardRef(FareItemNoPriceAvailableCmp);
FareItemNoPriceAvailable.componentName = 'FareItemNoPriceAvailable';

export default FareItemNoPriceAvailable;
